import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Summary from '../../components/Summary';
import { useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { selectAccessoryRequest, selectMaintenance, chooseInsuranceRequest, fetchCoupon, resetCoupon, sendCouponInfo, sendCotizacion, sendDescuento } from '../../actions';

const SummaryContainer = () => {
  const { personalization } = useSelector(state => ({
    personalization: state.personalization
  }));

  const { tipo, modelo, version, anio, color } = useParams();
  const dispatch = useDispatch();
  const selectAccessory = useCallback(
    accessory => {
      dispatch(
        selectAccessoryRequest(tipo, modelo, version, anio, color, accessory)
      );
    },
    [anio, color, dispatch, modelo, tipo, version]
  );

  const pickMaintenance = useCallback(
    maintenanceId => {
      dispatch(selectMaintenance(tipo, modelo, version, anio, color, maintenanceId, false));
  }, [anio, color, dispatch, modelo, tipo, version]);

  const pickInsurance = useCallback(
    insurance => {
      dispatch(chooseInsuranceRequest(tipo, modelo, version, anio, color, insurance));
  }, [anio, color, dispatch, modelo, tipo, version]);

  const checkCoupon = useCallback(
    coupon => {
      dispatch(fetchCoupon(coupon));
  }, [dispatch]);

  const resetCouponRequest = useCallback(
    coupon => {
      dispatch(resetCoupon());
  }, [dispatch]);

  const sendCouponForm = useCallback(
    (coupon, form, descuento) => {
      dispatch(
        sendCouponInfo({
          ...form,
          coupon,
          descuento
      }));
  }, [dispatch]);

  const sendCotizacionRequest = (cotizacion, descuentoWeb, isGasDiscount, campaingOverride) => {
    cotizacion.source = isGasDiscount ? 'CUPON GASOLINA' : (campaingOverride?.lead || "DESCUENTO WEB");
    cotizacion.descuentoWeb = true;
    cotizacion.descuentoWebMonto = isGasDiscount ? 0 : (campaingOverride?.price || descuentoWeb.monto);
    dispatch(sendCotizacion(tipo, modelo, version, anio, color, cotizacion));
  }

  const sendDescuentoRequest = useCallback((isGasDiscount) => {
    dispatch(sendDescuento(isGasDiscount));
  }, [dispatch]);
  

  return (
    <Summary 
      personalization={personalization} 
      selectAccessory={selectAccessory} 
      pickMaintenance={pickMaintenance} 
      pickInsurance={pickInsurance} 
      checkCoupon={checkCoupon}
      resetCouponRequest={resetCouponRequest}
      sendCouponForm={sendCouponForm}
      sendCotizacion={sendCotizacionRequest}
      sendDescuentoRequest={sendDescuentoRequest}
    />
  );
};

export default SummaryContainer
